/******/ (() => { // webpackBootstrap
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsDrawer = this.closest('[data-cart-drawer-recommendations]');
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.renderRecommendations = this.renderRecommendations.bind(this);
    this.updateSwiper = this.updateSwiper.bind(this);
    this.swiperCart = null;
    this._resizeObserver = null;
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-recommendations'});
    this.fetchRecommendations();

    // Debounced resize handler
    let resizeTimer;
    this._resizeHandler = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.updateSwiper(), 150);
    };
    window.addEventListener('resize', this._resizeHandler);
  }

  disconnectedCallback() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
  }

  shouldUseSwiper() {
    if (window.innerWidth <= 768) return true;
    return this.recommendationsDrawer && this.recommendationsDrawer.hasAttribute('data-card-drawer-recommendations-inline');
  }

  updateSwiper() {
    const swiperWrapperEl = this.recommendationsDrawer
      ? this.recommendationsDrawer.querySelector('[data-swiper-wrapper]')
      : null;

    if (this.shouldUseSwiper()) {
      // Ensure swiper-wrapper class is present before initializing
      if (swiperWrapperEl) swiperWrapperEl.classList.add('swiper-wrapper');

      /* GUILD LANE 2026-08-19. `Swiper` is a GLOBAL here, and there is no longer
         one: v2.4.2 removed the jsdelivr copy after an audit concluded every
         `new Swiper` call sat inside a webpack bundle carrying its own. This file
         is the exception — it is a plain module, not a bundle — so the removal
         left an uncaught ReferenceError on EVERY mobile cart open
         (shouldUseSwiper returns true below 769px), and the recommendations row
         never initialised. Live since 2026-08-17, reported by Sebo today.

         Not fixed by putting the library back: that was 202ms of render-blocking
         for one carousel. The row falls back to CSS scroll-snap instead, which is
         what the testimonials carousel on the Jubilee page now uses. */
      if (typeof Swiper === 'undefined') {
        if (swiperWrapperEl) {
          swiperWrapperEl.classList.remove('swiper-wrapper');
          swiperWrapperEl.classList.add('gl-snaprow');
        }
        return;
      }

      if (!this.swiperCart) {
        this.swiperCart = new Swiper('cart-recommendations.swiper', {
          direction: 'horizontal',
          loop: false,
          slidesPerView: 1.5,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    } else {
      // Destroy Swiper if it exists
      if (this.swiperCart) {
        this.swiperCart.destroy(true, true);
        this.swiperCart = null;
      }

      // Remove swiper-wrapper class when not using Swiper
      if (swiperWrapperEl) swiperWrapperEl.classList.remove('swiper-wrapper');
    }
  }

  async fetchRecommendations() {
    if (!this.url) return;

    try {
      const response = await fetch(this.url);

      if (response.ok) {
        const responseText = await response.text();
        this.renderRecommendations(responseText);
        this.updateSwiper();
      }
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    }
  }

  renderRecommendations(html) {
    const updatedContent = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    
    if (!updatedContent || updatedContent.trim().length === 0) {
      /* ===== If no recommendations, hide the secondary drawer ===== */
      this.closest('cart-drawer')?.classList.add('hide-recommendations');
    } else {
      /* ===== If recommendations, update content ===== */
      this.innerHTML = updatedContent;
      this.closest('cart-drawer')?.classList.remove('hide-recommendations');

      /* ===== Prevent mobile content shift with each fetch by fixing the parent height and re-calculating after each fetch ===== */
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        this.parentElement.style.height = 'auto';
        this.parentHeight = this.parentElement.getBoundingClientRect().height;
        this.parentElement.style.height = '';
        document.documentElement.style.setProperty('--cart-recommendations-height', `${this.parentHeight}px`);
      }

      let cartRecommendations = this.recommendationsDrawer.querySelectorAll('.product-card-basic');
      console.log(cartRecommendations);

      cartRecommendations.forEach(function(cartRecommendation) {
        let cartRecommendationVariant = cartRecommendation.querySelector('.shopify-product-form input[name="id"]');
        let cartRecommendationSelect = cartRecommendation.querySelector('.product-card-basic__variant select');
        if(cartRecommendationSelect) {
          cartRecommendationSelect.addEventListener('change', function() { 
            cartRecommendationVariant.value = cartRecommendationSelect.value;
            let selectedIndex = cartRecommendationSelect.selectedIndex;
            let selectedOption = cartRecommendationSelect.options[selectedIndex];
            let cartRecommendationImage = selectedOption.getAttribute('data-variant-image');
            let cartRecommendationPrice = selectedOption.getAttribute('data-variant-price');
            let cartRecommendationCompareAtPrice = selectedOption.getAttribute('data-variant-compare-at-price');
            let cartRecommentationElementImage = cartRecommendation.querySelector('.product-card-basic__image img');
            let cartRecommentationElementRegularPrice = cartRecommendation.querySelector('.price--regular-price');
            let cartRecommentationElementSalePrice = cartRecommendation.querySelector('.price--sale-price');
            let cartRecommentationElementCompareAtPrice = cartRecommendation.querySelector('.price--compare-at-price');
            if(cartRecommentationElementImage) {
              cartRecommentationElementImage.srcset = '';
              cartRecommentationElementImage.src = cartRecommendationImage;
            }
            if(cartRecommentationElementRegularPrice) {
              cartRecommentationElementRegularPrice.innerText = cartRecommendationPrice;
            }
            if(cartRecommentationElementSalePrice) {
              cartRecommentationElementSalePrice.innerText = cartRecommendationPrice;
            }
            if(cartRecommentationElementCompareAtPrice) {
              cartRecommentationElementCompareAtPrice.innerText = cartRecommendationCompareAtPrice;
            }
          });
        }
      });
    }
  }

  get url() {
    return this.getAttribute('data-cart-recommendations-url');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
/******/ })()
;